import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

var AppLightModal = /*#__PURE__*/function (_Vue) {
  _inherits(AppLightModal, _Vue);

  var _super = _createSuper(AppLightModal);

  function AppLightModal() {
    _classCallCheck(this, AppLightModal);

    return _super.apply(this, arguments);
  }

  _createClass(AppLightModal, [{
    key: "hide",
    value: function hide() {}
  }]);

  return AppLightModal;
}(Vue);

__decorate([Prop({
  type: String,
  default: 'white'
})], AppLightModal.prototype, "bg", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppLightModal.prototype, "fixed", void 0);

__decorate([Prop({
  type: [Number],
  default: 48
})], AppLightModal.prototype, "top", void 0);

__decorate([Emit('hide')], AppLightModal.prototype, "hide", null);

AppLightModal = __decorate([Component], AppLightModal);
export default AppLightModal;